export const DEFAULT_ASSIGNED_POLICY_PROJECT = { fullPath: '', branch: '' };

export const PAGE_SIZE = 20;

export const NAMESPACE_TYPES = {
  PROJECT: 'project',
  GROUP: 'group',
};

export const GROUP_TYPE = 'group';

export const ROLE_TYPE = 'role';

export const USER_TYPE = 'user';

export const EMPTY_TYPE = 'empty';

export const MAX_SCAN_EXECUTION_ACTION_COUNT = 10;
export const MAX_SCAN_EXECUTION_POLICY_SCHEDULED_RULES_COUNT = 30;
